import { createSlice } from '@reduxjs/toolkit'

const initialState = {
   channelsLoading: true,
   channels: [],
   qrLoading: false,
   qrCode: '',
   sourceId: '',
   isWhatsappScanStarted: false,
   maxQrLoading: false,
   maxQrCode: '',
   maxSourceId: '',
   isMaxScanStarted: false
}

const ChannelsStatuses = {
   ACTIVE: 1,
   INACTIVE: 0
}

export const channelsSlice = createSlice({
   name: 'channels',
   initialState,
   reducers: {
      fetchChannelsStarted: (state) => {
         state.channelsLoading = true
      },
      fetchChannelsSuccess: (state, action) => {
         state.channels = [ ...action.payload ]
      },
      fetchChannelsFinished: (state) => {
         state.channelsLoading = false
      },
      fetchWhatsappQrStarted: (state) => {
         state.qrLoading = true
         state.qrCode = ''
         state.sourceId = ''
      },
      fetchWhatsappQrSuccess: (state, action) => {
         state.qrCode = action.payload.qrCode
         state.sourceId = action.payload.sourceId
      },
      fetchWhatsappQrFinished: (state) => {
         state.qrLoading = false
      },
      clearWhatsappChannelData: (state) => {
         state.qrCode = ''
         state.sourceId = ''
         state.isWhatsappScanStarted = false
      },
      setWhatsappScanStarted: (state, action) => {
         state.isWhatsappScanStarted = action.payload
      },
      fetchMaxQrStarted: (state) => {
         state.maxQrLoading = true
         state.maxQrCode = ''
         state.maxSourceId = ''
      },
      fetchMaxQrSuccess: (state, action) => {
         state.maxQrCode = action.payload.qrCode || action.payload.qrLink || ''
         state.maxSourceId = action.payload.sourceId
      },
      fetchMaxQrFinished: (state) => {
         state.maxQrLoading = false
      },
      clearMaxChannelData: (state) => {
         state.maxQrCode = ''
         state.maxSourceId = ''
         state.isMaxScanStarted = false
      },
      setMaxScanStarted: (state, action) => {
         state.isMaxScanStarted = action.payload
      },
      activateChannelSuccess: (state, action) => {
         state.channels = state.channels.map(channel => (
            channel.id === action.payload
               ? { ...channel, status: ChannelsStatuses.ACTIVE }
               : channel
         ))
      },
      deactivateChannelSuccess: (state, action) => {
         state.channels = state.channels.map(channel => (
            channel.id === action.payload
               ? { ...channel, status: ChannelsStatuses.INACTIVE }
               : channel
         ))
      },
      deleteChannelSuccess: (state, action) => {
         state.channels = state.channels.filter(channel => channel.id !== action.payload)
      }
   }
})

export const { 
   fetchChannelsStarted, 
   fetchChannelsSuccess,
   fetchChannelsFinished,
   fetchWhatsappQrStarted,
   fetchWhatsappQrSuccess,
   fetchWhatsappQrFinished,
   clearWhatsappChannelData,
   setWhatsappScanStarted,
   fetchMaxQrStarted,
   fetchMaxQrSuccess,
   fetchMaxQrFinished,
   clearMaxChannelData,
   setMaxScanStarted,
   activateChannelSuccess,
   deactivateChannelSuccess,
   deleteChannelSuccess
} = channelsSlice.actions
export default channelsSlice.reducer